/******/ (() => { // webpackBootstrap
class CartQuantity extends HTMLElement {
  constructor() {
    super();
    this.removeButton = this.querySelector('[data-cart-remove-item]');
    this.adjustButtons = this.querySelectorAll('[data-cart-quantity-button]');
    this.input = this.querySelector('[data-cart-quantity-input]');
    this.cartCountIndicator = document.querySelector('[data-cart-count-indicator]');
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleQuantityChange = this.handleQuantityChange.bind(this);
    this.handleRemoveItem = this.handleRemoveItem.bind(this);
    this.updateCart = this.updateCart.bind(this);
    this.updateLineItem = this.updateLineItem.bind(this);
    this.updateCartCountIndicator = this.updateCartCountIndicator.bind(this);
    this.handleCartErrors = this.handleCartErrors.bind(this);
    this.setLoadingState = this.setLoadingState.bind(this);
    this.hideLoadingState = this.hideLoadingState.bind(this);
    this.setRemoveLoadingState = this.setRemoveLoadingState.bind(this);
    this.hideRemoveLoadingState = this.hideRemoveLoadingState.bind(this);
    
  }

  connectedCallback() {
    window.wetheme.webcomponentRegistry.register({key: 'component-cart-quantity'});
    this.removeButton?.addEventListener('click', this.handleRemoveItem);
    this.adjustButtons.forEach(button => button.addEventListener('click', this.handleButtonClick));
    this.input?.addEventListener('change', this.handleInputChange);    

 
    document.getElementById("cart-drawer-apply-discount").addEventListener("click", this.applyDiscount.bind(this));
    document.getElementById("cart-drawer-discount-code-box").addEventListener("click", this.removeDiscount.bind(this)); 
    // document.getElementById("apply-discount").addEventListener("click", this.applycartDiscount.bind(this));
    // document.getElementById("discount-code-box").addEventListener("click", this.removecartDiscount.bind(this)); 
    const applyDiscountButton = document.getElementById("apply-discount");
    const discountCodeBox = document.getElementById("discount-code-box");

    if (applyDiscountButton) {
        applyDiscountButton.addEventListener("click", this.applycartDiscount.bind(this));
    } else {
        console.warn('元素 "apply-discount" 不存在');
    }

    if (discountCodeBox) {
        discountCodeBox.addEventListener("click", this.removecartDiscount.bind(this));
    } else {
        console.warn('元素 "discount-code-box" 不存在');
    }

    // this.quantityEventListeners(); 
  }

  handleButtonClick(e) {
    /* ===== Handle the button click event ===== */
    e.preventDefault();
    const previousValue = this.input.value;
    const adjustment = e.currentTarget.name === 'plus' ? 1 : -1;

    // Adjust the quantity by the adjustment value
    this.adjustQuantity(adjustment);

    // Process the new quantity if quantity has changed
    if (previousValue !== this.input.value) {
      this.handleQuantityChange(this.input.value);
    }
  }

  adjustQuantity(adjustment) {
    /* ===== Adjust the quantity by the adjustment value ===== */
    const newValue = parseInt(this.input.value) + adjustment;
    // If the new value is not a number, set it to 1
    this.input.value = isNaN(newValue) ? 1 : newValue;

    // If the value is smaller than the min attribute, set it to the min attribute
    if (this.input.min && parseInt(this.input.value) < parseInt(this.input.min)) {
      this.input.value = this.input.min;
    }
  }

  handleInputChange(e) {
    /* ===== Handle the change event ===== */
    e.preventDefault();

    // If the value is not a number, set it to 1
    if (isNaN(this.input.value)) {
      this.input.value = 1;
    }

    // If the value is smaller than the min attribute, set it to the min attribute
    if (this.input.min && parseInt(this.input.value) < parseInt(this.input.min)) {
      this.input.value = this.input.min;
    }

    // Process the new quantity
    this.handleQuantityChange(this.input.value);
  }

  handleQuantityChange(inputValue) {
    /* ===== Update the cart with the new quantity ===== */
    const quantity = parseInt(inputValue);
    this.updateCart(this.itemIndex, quantity);
  }

  handleRemoveItem() {
    /* ===== Set quantity of line item to zero ===== */
    this.updateCart(this.itemIndex, 0);
  }

  async updateCart(line, quantity) {
    try {
      /* ===== Set the loading state ===== */
      this.setLoadingState();

      /* ===== If quantity is 0, set the 'remove' loading state ===== */
      if (quantity === 0) {
        this.setRemoveLoadingState();
      }

      /* ===== Update the line item quantity ===== */
      let response = await this.updateLineItem(line, quantity);
      if (!response) return;

      /* ===== If successful response and has gift wrap, update the gift wrap product quantity ===== */
      if (this.hasGiftWrap) {
        const adjustment = quantity - this.previousQuantity;
        const cart = await this.getCart();
        if (this.getGiftWrapLine(cart) && this.getGiftWrapQuantity(cart)) {
          response = await this.updateLineItem(this.getGiftWrapLine(cart), this.getGiftWrapQuantity(cart) + adjustment);
        }
      }
      if (!response) return;

      /* ===== If successful response, re-render the cart ===== */
      window.eventBus.emit('update:cart:drawer', response);

      /* ===== Update cart count ===== */
      this.updateCartCountIndicator();
      
      this.bindEventListeners();
      this.updateCartTotals();

    } catch (error) {
      console.error('Error updating cart:', error);
    }
  }


  async updateLineItem(line, quantity) {
    try {
      /* ===== Update line item quantity ===== */
      const body = JSON.stringify({
        line,
        quantity,
        sections: 'cart-drawer'
      });

      const response = await fetch(window.routes.cart_change_url, { 
        ...this.fetchConfig(),
        body
      });

      const responseText = await response.text();

      if (!responseText) {
        this.handleCartErrors();
        return null;
      }

      const parsedResponse = JSON.parse(responseText);

      /* ===== Handle errors ===== */
      if (parsedResponse.errors) {
        this.handleCartErrors(line, parsedResponse.errors);
        return null;
      }

      return parsedResponse;
    } catch (error) {
      console.error('Error updating cart line item:', error);
    }
  }

  fetchConfig(type = 'json') {
    /* ===== Create the fetch configuration object ===== */
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  }

  handleCartErrors(line, errors) {
    /* ===== Reset loading state and input value ===== */
    this.hideLoadingState();
    this.hideRemoveLoadingState();
    this.input.value = this.input.getAttribute('value');

    /* ===== Display the error message ===== */
    this.renderErrorMessage(line, errors);
  }

  renderErrorMessage(line, message) {
    /* ===== Display the error message ===== */
    const errorElement = document.querySelector(`[data-cart-error-index="${line}"]`);
    if (!errorElement) return;
    errorElement.innerHTML = message;
    errorElement.setAttribute('aria-hidden', false);

    /* ===== If we're at the bottom of the cart, scroll error message into view ===== */
    const isLastItem = errorElement.getAttribute('data-cart-is-last-item') === 'true';
    if (isLastItem) {
      errorElement.scrollIntoView({ behavior: 'smooth' });
    }
  }

  async getCart() {
    /* ===== Fetch the cart information ===== */
    try {
      const response = await fetch(`${window.routes.cart_url}?view=compare`);
      return await response.json();
    } catch (error) {
      console.error(`Error fetching cart: ${error.description || error.message}`);
    }
  }

  updateCartCountIndicator() {
    /* ===== Update the cart count indicator ===== */
    if (!this.cartCountIndicator) return;
    this.getCart().then(cart => window.wetheme.updateCartCount(cart));
  }

  getGiftWrapLine(cart) {
    return cart.items.findIndex(item => item.variant_id === this.giftWrapVariantId) + 1 || null;
  }

  getGiftWrapQuantity(cart) {
    return cart.items.find(item => item.variant_id === this.giftWrapVariantId)?.quantity || null;
  }

  setLoadingState() {
    this.classList.add('is-loading');
  }

  hideLoadingState() {
    this.classList.remove('is-loading');
  }

  setRemoveLoadingState() {
    this.classList.add('is-removing');
  }

  hideRemoveLoadingState() {
    this.classList.remove('is-removing');
  }


  






// new discount code
bindEventListeners() {
    const applyDiscountButton = document.getElementById("cart-drawer-apply-discount");
    const discountCodeBox = document.getElementById("cart-drawer-discount-code-box");


    applyDiscountButton.removeEventListener("click", this.applyDiscount.bind(this));
    discountCodeBox.removeEventListener("click", this.removeDiscount.bind(this));

   
    applyDiscountButton.addEventListener("click", this.applyDiscount.bind(this));
    discountCodeBox.addEventListener("click", this.removeDiscount.bind(this));

    // cart
    
    const cartapplyDiscountButton = document.getElementById("apply-discount");
    const cartdiscountCodeBox = document.getElementById("discount-code-box");

      if (cartapplyDiscountButton) {
        
        cartapplyDiscountButton.removeEventListener("click", this.applycartDiscount.bind(this));
        cartdiscountCodeBox.removeEventListener("click", this.removecartDiscount.bind(this));
      
        cartapplyDiscountButton.addEventListener("click", this.applycartDiscount.bind(this));
        cartdiscountCodeBox.addEventListener("click", this.removecartDiscount.bind(this));
      } 
}


    applyDiscount(event) {
        event.preventDefault();
        const discountCode = document.getElementById('cart-drawer-discount-input').value.trim().toLowerCase();
        const discountSpan = document.getElementById('cart-drawer-discount-code-box');
  console.log('点击:');
        if (discountSpan.querySelector('.cart-drawer-discount-code-title') === null) {
            const url = '/checkout?discount=' + encodeURIComponent(discountCode);

            fetch(url)
                .then(response => {
                    if (!response.ok) throw new Error('Network response was not ok');
                    return response.json();
                })
                .then(data => {
                    this.updateCartDrawer(discountCode);
                })
                .catch(error => {
                    console.error('Error applying discount code:', error);
                    this.updateCartDrawer();
                });
        } else {
            const discountTitles = Array.from(discountSpan.querySelectorAll('.cart-drawer-discount-code-title'))
                .map(title => title.textContent.trim())
                .join(',');

            const url = '/checkout?discount=' + encodeURIComponent(discountCode) + ',' + encodeURIComponent(discountTitles);
            fetch(url)
                .then(response => {
                    if (!response.ok) throw new Error('Network response was not ok');
                    return response.json();
                })
                .then(data => {
                    this.updateCartDrawer(discountCode);
                })
                .catch(error => {
                    console.error('Error applying discount code:', error);
                    this.updateCartDrawer();
                });
        }
    }

 removeDiscount(event) {
   
    if (!event.target.closest('.cart-drawer-removecode')) {
        return; 
    }

    const clickedSpan = event.target.closest('.cart-drawer-discount-code-box-span');
    const discountSpan = document.getElementById('cart-drawer-discount-code-box');
    const allDiscountTitles = discountSpan.querySelectorAll('.cart-drawer-discount-code-title');
    const currentTitleValue = clickedSpan.querySelector('.cart-drawer-discount-code-title').textContent.trim();

    
    const titlesParam = Array.from(allDiscountTitles).map(title => title.textContent.trim())
        .filter(title => title !== currentTitleValue)
        .join(',');

   
    const url = titlesParam
        ? '/checkout?discount=' + encodeURIComponent(titlesParam)
        : '/checkout?discount=';

    fetch(url)
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.json();
        })
        .then(data => {
            clickedSpan.remove(); 
            document.getElementById('cart-drawer-discount-code-info-text').innerHTML = ""; 
            this.updateCartDrawer(discountCode);
        })
        .catch(error => {
            console.error('Error while removing discount:1', error);
            this.updateCartDrawer();
        });
}


// cart

    applycartDiscount(event) {
        event.preventDefault();
        const discountCode = document.getElementById('discount-input').value.trim().toLowerCase();
        const discountSpan = document.getElementById('discount-code-box');

        if (discountSpan.querySelector('.discount-code-title') === null) {
            const url = '/checkout?discount=' + encodeURIComponent(discountCode);

            fetch(url)
                .then(response => {
                    if (!response.ok) throw new Error('Network response was not ok');
                    return response.json();
                })
                .then(data => {
                    this.updateCartDrawer(discountCode);
                })
                .catch(error => {
                    console.error('Error applying discount code:', error);
                    this.updateCartDrawer();
                });
        } else {
            const discountTitles = Array.from(discountSpan.querySelectorAll('.discount-code-title'))
                .map(title => title.textContent.trim())
                .join(',');

            const url = '/checkout?discount=' + encodeURIComponent(discountCode) + ',' + encodeURIComponent(discountTitles);
            fetch(url)
                .then(response => {
                    if (!response.ok) throw new Error('Network response was not ok');
                    return response.json();
                })
                .then(data => {
                    this.updateCartDrawer(discountCode)
                })
                .catch(error => {
                    console.error('Error applying discount code:', error);
                    this.updateCartDrawer()
                });
        }
    }

 removecartDiscount(event) {
   
    if (!event.target.closest('.removecode')) {
        return; 
    }

    const clickedSpan = event.target.closest('.discount-code-box-span');
    const discountSpan = document.getElementById('discount-code-box');
    const allDiscountTitles = discountSpan.querySelectorAll('.discount-code-title');
    const currentTitleValue = clickedSpan.querySelector('.discount-code-title').textContent.trim();

    
    const titlesParam = Array.from(allDiscountTitles).map(title => title.textContent.trim())
        .filter(title => title !== currentTitleValue)
        .join(',');

   
    const url = titlesParam
        ? '/checkout?discount=' + encodeURIComponent(titlesParam)
        : '/checkout?discount=';

    fetch(url)
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.json();
        })
        .then(data => {
            clickedSpan.remove(); 
            document.getElementById('discount-code-info-text').innerHTML = ""; 
            this.updateCartDrawer(discountCode)
        })
        .catch(error => {
            console.error('Error while removing discount:1', error);
            this.updateCartDrawer()
        });
}



  updateCartDrawer() {
     const firstProductCard = document.querySelector('#CartDrawer-Form .cart-drawer__product_card');

    if (firstProductCard) {
        const quantity = firstProductCard.getAttribute('data-quantity');
        console.log('First product card quantity:', quantity); 
        this.updateCart(1, quantity)
    } else {
        console.warn('No product cards found in #CartDrawer-Form.');
    }
    // this.refreshCart();
  }


//     quantityEventListeners() {
//         document.querySelectorAll('.js-qty__adjust').forEach(button => {
//             button.addEventListener('click', this.adjustQuantitycart.bind(this));
//         });
//     }

//     adjustQuantitycart(event) {
//         // const indexData = event.target.getAttribute('index-data'); // 获取 index-data 属性值
//         const indexData = event.target.closest('.js-qty').getAttribute('index-data');

//         const nameButton = event.target.closest('button');
//         const isAddButton = nameButton.classList.contains('js-qty__adjust--plus');
        
//         const quantityButton = document.querySelector(`#CartDrawer-Form .cart-drawer__product_card[data-index="${indexData}"]`);

//         if (!quantityButton) return; 
//         if (isAddButton) {
//             const plusButton = quantityButton.querySelector('.cart-drawer-item-plus');
//             plusButton.click(); 
//         } else {
//             const minusButton = quantityButton.querySelector('.cart-drawer-item-minus');
//             if (minusButton) {
//                 minusButton.click(); 
//             }
//         }
        
//     setTimeout(() => {
//        this.updateCartDrawer();
//     }, 1000); 
//   }

   updateCartTotals() {
    fetch('/cart') // 发送请求获取购物车信息
        .then(response => response.text())
        .then(data => {
                  console.log('改值4');
            var tempElement = document.createElement('div');
            tempElement.innerHTML = data;

            var updatedTotals = tempElement.querySelectorAll('.cart-total-price-td');
            var totalElements = document.querySelectorAll('.cart-total-price-td');

            totalElements.forEach((element, index) => {
                if (updatedTotals[index]) {
                    element.innerHTML = updatedTotals[index].innerHTML;
                }
            });

            var updatedDiscount = tempElement.querySelector('.cart-page-total-box');
            var discountElement = document.querySelector('.cart-page-total-box');

            if (updatedDiscount && discountElement) {
                discountElement.innerHTML = updatedDiscount.innerHTML;
            }

            
            var updatedqty = tempElement.querySelectorAll('.cart_qty_box');
            var qtyElements = document.querySelectorAll('.cart_qty_box');

            qtyElements.forEach((element, index) => {
                if (updatedqty[index]) {
                  console.log('改值2');
                    element.innerHTML = updatedqty[index].innerHTML;
                }
            });

            
         
            var updatedCode = tempElement.querySelector('.discount-code-info');
            var codeElement = document.querySelector('.discount-code-info');

            if (updatedCode && codeElement) {
                codeElement.innerHTML = updatedCode.innerHTML;
            }
            document.getElementById("discount-code-box").addEventListener("click", this.removecartDiscount.bind(this));
            document.getElementById("cart-drawer-discount-code-box").addEventListener("click", this.removeDiscount.bind(this)); 

        })
        .catch(error => {
            console.error('Error fetching cart totals:', error);
        });
}






  get itemIndex() {
    return parseInt(this.getAttribute('data-item-index'));
  }

  get previousQuantity() {
    return parseInt(this.getAttribute('data-item-quantity'));
  }

  get hasGiftWrap() {
    return this.getAttribute('data-has-gift-wrap') === "true";
  }

  get giftWrapVariantId() {
    return parseInt(this.getAttribute('data-gift-wrap-variant-id'));
  }
}



customElements.define('cart-quantity', CartQuantity);
/******/ })()
;